import React, { useState, useEffect } from 'react';
import { Badge, Button, Col, Form, Image, InputGroup, Modal, Row, Table, Nav, Space, Input, Select, Card, Alert, Spinner } from "react-bootstrap";
import { Dropdown, ButtonGroup } from "react-bootstrap";
import { message, Spin } from "antd";
import { oneKlicks } from "../../SDK/oneclick";
import ImageShow from '../../Uitiles/ImageShow';
import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';
import AddInvoiceModel from './Components/AddInvoiceModel';
import { toast } from 'react-toastify';
import formatDoctorName from '../../Uitiles/FormatName';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';
import Paginationnew from '../../Uitiles/Paginationnew';
import { genareteInvoicePDF } from '../../services/apiService';
import { generatePDFFromHTML } from '../../Uitiles/GeneratePDFFromHTML';

// Invoice Preview Component
const InvoicePreviewContent = ({ invoiceId }) => {
    const [invoiceHTML, setInvoiceHTML] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchInvoiceHTML = async () => {
            try {
                setLoading(true);
                const html = await genareteInvoicePDF(invoiceId);
                setInvoiceHTML(html);
            } catch (err) {
                console.error("Error fetching invoice HTML:", err);
                setError("Failed to load invoice preview");
            } finally {
                setLoading(false);
            }
        };

        if (invoiceId) {
            fetchInvoiceHTML();
        }
    }, [invoiceId]);

    if (loading) {
        return (
            <div style={{ textAlign: 'center', padding: '50px' }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
                <p style={{ marginTop: '10px' }}>Loading invoice preview...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div style={{ textAlign: 'center', padding: '50px', color: '#e74c3c' }}>
                <i className="fas fa-exclamation-triangle" style={{ fontSize: '48px', marginBottom: '20px' }}></i>
                <p>{error}</p>
            </div>
        );
    }

    if (!invoiceHTML) {
        return (
            <div style={{ textAlign: 'center', padding: '50px' }}>
                <p>No invoice data available</p>
            </div>
        );
    }

    return (
        <div style={{
            transform: 'scale(0.8)',
            transformOrigin: 'top left',
            width: '125%'
        }}>
            {invoiceHTML}
        </div>
    );
};


const Invoices = () => {
    const [search, setSearch] = useState('');
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [showView, setShowView] = useState(false);
    const [clients, setClients] = useState([]);
    const [showEmail, setShowEmail] = useState(false);
    const [clientList, setClientList] = useState([]);
    const [searchClient, setSearchClient] = useState('');
    const [showPDFPreview, setShowPDFPreview] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [editData, setEditData] = useState({});
    const [showEdit, setShowEdit] = useState(false);
    const [showmainloader, setShowmainloader] = useState(false);
    const [showpdfdownloader, setShowpdfdownloader] = useState("");
    const [formData, setFormData] = useState({
        clientName: '',
        clientEmail: '',
        packageType: '',
        amount: '',
        description: '',
        dueDate: ''
    });
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [limit, setLimit] = useState(10);

    const getStatusBadge = (status) => {
        switch (status) {
            case 'Paid':
                return <Badge bg="success">Paid</Badge>;
            case 'Pending':
                return <Badge bg="warning">Pending</Badge>;
            case 'Overdue':
                return <Badge bg="danger">Overdue</Badge>;
            case 'Draft':
                return <Badge bg="secondary">Draft</Badge>;
            default:
                return <Badge bg="info">{status}</Badge>;
        }
    };

    const openAdd = () => {
        setShowAdd(true);
    };

    const openView = (invoice) => {
        setEditData(invoice);
        setShowView(true);
    };

    const openEdit = (invoice) => {
        setEditData(invoice);
        setShowEdit(true);
    };

    const openEmail = (invoice) => {
        setSelectedInvoice(invoice);
        setShowEmail(true);
    };

    const openPDFPreview = async (invoice) => {
        setShowmainloader(true);
        try {
            setShowPDFPreview(true);
            const invoiceHTML = await genareteInvoicePDF(invoice.id);

            // Create a temporary container to render the HTML
            const tempContainer = document.createElement('div');
            tempContainer.style.position = 'absolute';
            tempContainer.style.left = '-9999px';
            tempContainer.style.top = '-9999px';
            tempContainer.style.width = '210mm';
            tempContainer.style.backgroundColor = 'white';
            document.body.appendChild(tempContainer);

            // Render the React component to the container
            const { createRoot } = require('react-dom/client');
            const root = createRoot(tempContainer);
            root.render(invoiceHTML);

            // Wait for rendering to complete
            await new Promise(resolve => setTimeout(resolve, 1000));

            // Convert to canvas png image
            const canvas = await html2canvas(tempContainer, {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                backgroundColor: '#ffffff'
            });

            // Clean up
            root.unmount();
            document.body.removeChild(tempContainer);

            // Convert canvas to image data URL
            const imageDataURL = canvas.toDataURL('image/png');

            console.log("Canvas generated:", canvas);
            setSelectedInvoice({ ...invoice, canvasImage: imageDataURL });

        } catch (error) {
            console.error("Error generating invoice PDF:", error);
            toast.error("Failed to generate invoice preview");
        } finally {
            setShowmainloader(false);
        }
    };



    const handleDownload = async (invoice) => {
        setShowpdfdownloader(invoice.id);
        toast.success(`Downloading invoice #${invoice.id} Started Waiting...`); 
        const response = await generatePDFFromHTML(invoice);
        if (response) {
            setShowpdfdownloader("");
            toast.success(`Downloading invoice #${invoice.id} Completed`);
        } else {
            setShowpdfdownloader("");
            toast.error('Failed to generate invoice PDF');
        }
    };

    const handleDelete = async (invoiceId) => {
        if (window.confirm('Are you sure you want to delete this invoice?')) {
            setInvoices(invoices.filter(inv => inv.id !== invoiceId));
            const tableSchema = '';
            const tableName = 'invoices';
            const conditions = { id: invoiceId };
            const response = await oneKlicks.delete(tableSchema, tableName, conditions);
            if (response.success) {
                const tableSchema = '';
                const tableName = 'invoice_items';
                const conditions = { invoice_id: invoiceId };
                const deleteInvoiceItems = await oneKlicks.delete(tableSchema, tableName, conditions);
                if (deleteInvoiceItems.success) {
                    toast.success('Invoice deleted successfully');
                } else {
                    toast.error('Failed to delete invoice items');
                }
            } else {
                toast.error('Failed to delete invoice');
            }
        }
    };



    useEffect(() => {
        getInvoices();

    }, []);

    useEffect(() => {
        getInvoices();
    }, [page, limit]);

    const getInvoices = async () => {
        setLoading(true);
        try {
            const tableSchema = '';
            const tableName = 'invoices';
            const conditions = {

            };
            const orderBy = 'id DESC';
            const search = {};
            const pagination = { page: page, limit: limit };
            const margedata = [
                {
                    "target_table": "users",
                    "target_column": "id",
                    "target_value": "client",
                    "target_label": "users"
                },
                {
                    "target_table": "packages",
                    "target_column": "id",
                    "target_value": "package",
                    "target_label": "packages"
                }
            ];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("getInvoices response", response);
            if (response.success) {
                setInvoices([])
                setInvoices(response.data);
                setTotalPages(response.totalPages);
            }
        } catch (error) {
            console.error('Error fetching invoices:', error);
        } finally {
            setLoading(false);
        }
    };

    const getClients = async (name = '', type = '') => {
        const tableSchema = '';
        const tableName = 'users';
        const conditions = {
            user_type: type
        };
        const orderBy = 'id DESC';
        const search = {
            ...(name ? { display_name: name } : {}),
            ...(name ? { email: name } : {}),
            ...(name ? { phone: name } : {})
        };
        const pagination = {};
        const margedata = [];
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        console.log("getClients response", response);
        if (response.success) {
            console.log("getClients response", response.data);
            setClients(response.data);
        } else {
            setClients([]);
        }
    };

    const handleClientChange = (value) => {
        setClientList([]);
        setSearchClient(value);
        getClients(value, formData.userType);
    };

    const handleClientSelect = (c) => {
        setClientList([]);
        setSearchClient(formatDoctorName(c.display_name));
        setFormData(prev => ({
            ...prev,
            client: c.id
        }));
    };

    const handlePageChange = (page) => {
        setPage(page);
    };

    const handleClienttype = (type) => {
        setClientList([]);
        setSearchClient('');
        getClients('', type);
    };

    return (
        <div className="dc-haslayout dc-dbsectionspace">
            <div className="container-fluid py-3">
                <div className="card mb-5">
                    <div className="card-body">
                        <div className="align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center gap-2  mb-2">
                                <h5 className="mb-0 font-weight-bold mr-3">Invoices</h5>
                                <Badge bg="info">Management</Badge>
                            </div>
                            <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                                <InputGroup className="p-0" style={{ maxWidth: 400, flex: "1 1 auto" }}>
                                    <Form.Control
                                        placeholder="Search..."
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </InputGroup>
                                <Button variant="primary" onClick={openAdd}>+ Add Invoice</Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <Table hover size="sm" className="mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th>Order ID</th>
                                        <th>Invoice Type</th>
                                        <th style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>Client</th>
                                        <th style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>Due Date</th>
                                        <th>Created date</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                        <th width="300px">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan={7} className="text-center">
                                                <Spinner animation="border" variant="primary" />
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            {invoices.map((invoice) => (
                                                <tr key={invoice.id}>
                                                    <td data-label="Order ID"><strong>#{invoice.id}</strong></td>
                                                    <td data-label="Invoice Type">
                                                        <Badge bg={invoice.invoiceType === 'Invoice' ? 'primary' : 'info'} className="text-capitalize" style={{ textTransform: 'capitalize', color: 'white' }}>
                                                            {invoice.invoiceType}
                                                        </Badge>
                                                    </td>
                                                    <td data-label="Client">
                                                        <span className="d-flex gap-2" style={{ gap: 10, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flexDirection: 'row' }}>
                                                            <div style={{ width: 40, height: 40 }}>
                                                                <ImageShow url={invoice.users[0].profile_photo_url} width={40} height={40} style={{ borderRadius: 50 }} />
                                                            </div>

                                                            <div style={{ maxWidth: 200, alignItems: 'start', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'flex', flexDirection: 'column', gap: 5 }}>
                                                                <p height={20} style={{ marginBottom: 0, fontWeight: 600 }}>{invoice.users[0].display_name}</p>
                                                                <p height={20} style={{ marginBottom: 0, fontSize: '0.85rem', color: '#6c757d' }}>{invoice.users[0].email}</p>
                                                            </div>
                                                        </span>
                                                    </td>
                                                    <td data-label="Due Date">{new Date(invoice.dueDate).toLocaleDateString()}</td>
                                                    <td data-label="Created Date">{new Date(invoice.created_at).toLocaleDateString()}</td>
                                                    <td data-label="Amount"><strong>₹{invoice.total_amount}</strong></td>
                                                    <td data-label="Status">{getStatusBadge(invoice.status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()))}</td>
                                                    <td data-label="Action">
                                                        <span className="d-flex gap-1" style={{ display: 'flex', gap: 8, flexDirection: 'row', justifyContent: 'flex-end' }}>
                                                            <Button variant="info" size="sm" className="fit-content" onClick={() => openView(invoice)} title="View Details">
                                                                <i className="fas fa-eye"></i>
                                                            </Button>
                                                            <Button variant="" size="sm" className="fit-content" onClick={() => openEdit(invoice)} title="Edit">
                                                                <i className="fas fa-edit"></i>
                                                            </Button>
                                                            <Button variant="" size="sm" className="fit-content" onClick={() => openPDFPreview(invoice)} title="Preview PDF">
                                                                <i className="fas fa-file-pdf"></i>
                                                            </Button>
                                                            <Button variant="info" size="sm" className="fit-content" onClick={() => handleDownload(invoice)} title="Download PDF">
                                                                {showpdfdownloader === invoice.id ? (
                                                                    <Spin />
                                                                ) : (
                                                                    <i className="fas fa-download"></i>
                                                                )}
                                                            </Button>
                                                            <Button variant="success" size="sm" className="fit-content" onClick={() => openEmail(invoice)} title="Send Email">
                                                                <i className="fas fa-envelope"></i>
                                                            </Button>
                                                            <Button variant="danger" size="sm" className="fit-content" onClick={() => handleDelete(invoice.id)} title="Delete">
                                                                <i className="fas fa-trash"></i>
                                                            </Button>
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </>

                                    )}

                                </tbody>
                            </Table>

                        </div>
                        <Paginationnew currentPage={page} totalPages={totalPages} handlePageChange={handlePageChange} />
                    </div>
                </div>
            </div>

            {/* Add Invoice Modal */}
            <AddInvoiceModel showAdd={showAdd} setShowAdd={setShowAdd} data={{}} mode={"add"} getdata={getInvoices} />

            {/* View Invoice Modal */}
            {showView && (
                <AddInvoiceModel showAdd={showView} setShowAdd={setShowView} data={editData} mode={'view'} getdata={getInvoices} />
            )}

            {/* Edit Invoice Modal */}
            {showEdit && (
                <AddInvoiceModel showAdd={showEdit} setShowAdd={setShowEdit} data={editData} mode={'edit'} getdata={getInvoices} />
            )}

            {/* Email Invoice Modal */}
            <Modal show={showEmail} onHide={() => setShowEmail(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Send Invoice via Email</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedInvoice && (
                        <div>
                            <Alert variant="info">
                                <strong>Invoice #{selectedInvoice.id}</strong> will be sent to <strong>{selectedInvoice.client.email}</strong>
                            </Alert>
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Subject</Form.Label>
                                    <Form.Control
                                        type="text"
                                        defaultValue={`Invoice #${selectedInvoice.id} - ${selectedInvoice.package}`}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Message</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={4}
                                        defaultValue={`Dear ${selectedInvoice.client.name},\n\nPlease find attached your invoice #${selectedInvoice.id} for ${selectedInvoice.package}.\n\nAmount: ₹${String(selectedInvoice.amount).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}\nDue Date: ${selectedInvoice.dueDate}\n\nThank you for your business!\n\nBest regards,\nMeddyList Team`}
                                    />
                                </Form.Group>
                            </Form>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEmail(false)}>
                        Cancel
                    </Button>
                    <Button variant="success" onClick={() => {
                        toast.success(`Invoice sent to ${selectedInvoice?.client.email}`);
                        setShowEmail(false);
                    }}>
                        <i className="fas fa-envelope me-2"></i>Send Email
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* PDF Preview Modal */}
            <Modal show={showPDFPreview} onHide={() => setShowPDFPreview(false)} size="xl">
                <Modal.Header>
                    <Modal.Title>PDF Preview - Invoice #{selectedInvoice?.id}</Modal.Title>
                    <Button onClick={() => setShowPDFPreview(false)}>
                        <i className="fas fa-close"></i>
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    {selectedInvoice && (
                        <div className="pdf-preview-container">
                            <div className="pdf-preview" style={{
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                padding: '20px',
                                backgroundColor: '#f8f9fa',
                                fontFamily: 'Arial, sans-serif',
                                maxHeight: '70vh',
                                overflow: 'auto',
                                textAlign: 'center'
                            }}>
                                {showmainloader ? (
                                    <div className="text-center">
                                        <p>Loading...</p>
                                    </div>
                                ) : (
                                    selectedInvoice.canvasImage ? (
                                        <div>
                                            <img
                                                src={selectedInvoice.canvasImage}
                                                alt="Invoice Preview"
                                                style={{
                                                    maxWidth: '100%',
                                                    height: 'auto',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                                }}
                                            />
                                            <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                                                Invoice Preview - Click download to get PDF version
                                            </div>
                                        </div>
                                    ) : (
                                        <InvoicePreviewContent invoiceId={selectedInvoice.id} />
                                    )
                                )}
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowPDFPreview(false)}>
                        Close
                    </Button>
                    {selectedInvoice?.canvasImage && (
                        <Button variant="info" onClick={() => {
                            const link = document.createElement('a');
                            link.download = `invoice-${selectedInvoice.id}-preview.png`;
                            link.href = selectedInvoice.canvasImage;
                            link.click();
                        }}>
                            <i className="fas fa-image me-2"></i>Download Image
                        </Button>
                    )}
                    <Button variant="warning" onClick={() => {
                        generatePDFFromHTML(selectedInvoice);
                        setShowPDFPreview(false);
                    }}>
                        <i className="fas fa-download me-2"></i>Download PDF
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Invoices;
